export default {
    pageTitle: 'Livraisons',
};
